import { TextInput } from '@helix-ds/react'
import React from 'react'

type Props = {
  id: string
  label: string
  type: 'text' | 'email' | 'tel' | 'date'
  value: string
  onChange: (value: string) => void
  onBlur?: (value: string) => void
  error?: string
  required?: boolean
  /** Grid placement for the field within the modal's two-column layout. */
  wrapperClassName?: string
  inputRef?: (element: HTMLInputElement | null) => void
}

// Helix's own `error` prop renders a plain red span with no role, no aria-invalid, and nothing
// for aria-describedby to point at, so the message is owned here instead and the invalid styling
// is driven off aria-invalid (an attribute selector, so it reliably beats the base border class).
const ERROR_STATE_CLASSES =
  'aria-invalid:border-red-500 aria-invalid:focus:border-red-500 aria-invalid:focus:ring-red-500/20'

const DemographicsTextField: React.FC<Props> = ({
  id,
  label,
  type,
  value,
  onChange,
  onBlur,
  error,
  required,
  wrapperClassName,
  inputRef,
}) => {
  const errorId = `${id}-error`
  return (
    <div className={wrapperClassName}>
      <TextInput
        id={id}
        ref={inputRef}
        type={type}
        label={label}
        required={required}
        value={value}
        inputSize="lg"
        className={ERROR_STATE_CLASSES}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error ? errorId : undefined}
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => onBlur?.(e.target.value)}
      />
      {error && (
        <p id={errorId} className="mt-1 text-sm text-red-600 dark:text-red-400" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}

export default DemographicsTextField
